/**
 * AgentDataPassMessage Handler calls IJSF to fire onAgentDataPass event with a message
 * ACIF is listening to the event and builds a Dynamic Form with given message.
 *
 * package: com.inq.flash.client.control.messagehandlers
 * class: AgentDataPassMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_AGENT_DATA_PASS);
};

$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
    com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler,
    "com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler"
);

/**
 * Process message
 *
 * @param {com.inq.flash.messagingframework.Message} message - received message from server
 */
com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler.prototype.processMessage = function (message) {
	com.inq.flash.client.chatskins.SkinControl.getChatWindow().removeSystemMessageAndRerender();
	com.inq.flash.client.control.Incrementality.onAgentDataPass(message);
};

/** @type {com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler} */
com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler;
